/**
 * @module portal\permission
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhClassService from "@/utils/mixins/clsService";
import { MethodService } from "@/utils/serviceModel";
import { ElTree } from "element-ui/types/tree";

@Component
export default class Permission extends GhClassService {
  protected module = "portal.permission";
  protected cls = "PermissionService";
  private selectedRole: IndexObject = {};

  private selected: IndexObject = {};

  private permissions = [];

  protected serviceMethods = {
    get_all_menus: null,
    get_roles: null,
    get_permission: null,
    save: null
  };

  // private get

  private clickMenu(item) {
    this.selectedRole = {};
    this.$set(this.selectedRole, item.Id, !this.selectedRole[item.Id]);
    this.selected = item;

    this.getPermisssions();
  }

  private async getPermisssions() {
    this.permissions = [];
    if (this.selected) {
      if (this.selected.Id) {
        let service = (this.serviceMethods
          .get_permission as any) as MethodService;

        try {
          this.$setLoading(true);
          await service.invokeAsyn({ role_id: this.selected.Id });
          this.permissions = service.data;
          if (this.treeMenu) {
            this.treeMenu.setCheckedKeys(this.permissions);
          }
        } catch (error) {
        } finally {
          this.$setLoading(false);
        }
      }
    }
  }

  private async save() {
    if (!this.selected) {
      return;
    }

    if (!this.treeMenu) {
      return;
    }
    let keys = this.treeMenu.getCheckedKeys(true);
    let service = (this.serviceMethods.save as any) as MethodService;
    try {
      this.$setLoading(true);
      await service.invokeAsyn({ role_id: this.selected.Id, menu_ids: keys });
      await this.getPermisssions();
    } catch (error) {
    } finally {
      this.$setLoading(false);
    }
  }

  private get treeMenu(): ElTree<any,any> {
    let tree = this.$refs.treeMenus as ElTree<any,any>;
    return tree;
  }

  created() {
    this.fetchRoles();
    this.fetchMenus();
  }

  private fetchRoles() {
    let sv1 = (this.serviceMethods.get_roles as any) as MethodService;
    let enterprise = this.loginer.Site ? this.loginer.Site.Id : null;
    sv1.invokeAsyn({ enterprise });
  }

  private async fetchMenus() {
    try {
      this.$setLoading(true);
      let sv2 = (this.serviceMethods.get_all_menus as any) as MethodService;
      await sv2.invokeAsyn({});
    } catch (error) {
    } finally {
      this.$setLoading(false);
    }
  }

  private configRole() {
    this.navigate("portal.role");
  }
}
